"use client"
import { SVGProps } from "react"
const FormSuccessIconCareer = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.6654 18.4666V19.9999C36.6633 23.594 35.4995 27.0911 33.3476 29.9696C31.1956 32.8482 28.1708 34.9541 24.7243 35.9731C21.2777 36.9921 17.5941 36.8698 14.2228 35.6242C10.8515 34.3787 7.97312 32.0768 6.01697 29.0617C4.06081 26.0467 3.13168 22.48 3.36816 18.8938C3.60464 15.3075 4.99404 11.8938 7.32916 9.16173C9.66429 6.42964 12.82 4.52557 16.3257 3.73351C19.8314 2.94145 23.4991 3.30383 26.782 4.7666"
        stroke="#008015"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6667 6.6665L20 23.3498L15 18.3498"
        stroke="#008015"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default FormSuccessIconCareer
